import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import Swal from 'sweetalert2';
import { get_token } from "@/router";
import FormView from '@/components/view_forms/ViewForms.vue';
import AssignQuestion from '@/components/AssignQuestion/AssignQuestion.vue';
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';


export default {
    components: {
        Sidebar,
        Navbar,
        FormView,
        AssignQuestion,
        InactivityModal
    },

    mounted() {
        this.fetchSections().then(() => {
            this.$nextTick(() => {
                setTimeout(() => {
                    const table = $('#questionsTable');
                    if (table.length && !$.fn.dataTable.isDataTable(table)) {
                        table.DataTable({
                            paging: true,
                            searching: true,
                            ordering: true,
                            info: true,
                            lengthChange: true,
                            pageLength: 10,
                            language: {
                                paginate: {
                                    previous: "Previous",
                                    next: "Next"
                                },
                                info: "Showing _START_ to _END_ of _TOTAL_ entries",
                                infoEmpty: "No entries available"
                            }
                        });
                    }
                }, 100);
            });
        });

    },
    data() {
        return ({
            activeTab: 'sections',
            sections: [],
            section_name: '',
            isLoading: false,
            token_exists: false,
            edit_section: '',
            selected_section_id: '',
            is_locked: false,
            errors: {
                section_name: '',
            },
            form_id: this.$route.params.form_id,
        });
    },

    methods: {
        getToken() {
            return get_token();
        },
        toggleSidebar() {
            this.$refs.sidebar.$el.classList.toggle("close");
        },

        get_question_types() {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_question_types/`,
                method: "GET",
                headers: this.token_exists
                    ? { Authorization: `Token ${this.getToken()}` }
                    : {},
                success: (response) => {
                    this.question_types = response.data.question_types;
                },
                error: () => {
                    Swal.fire({
                        icon: "error",
                        title: "Failed to load question types",
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                }
            });
        },
        fetchSections() {
            return new Promise((resolve, reject) => {
                const form_id = this.$route.params.form_id;
                const payload = { "form_id": form_id };

                $.ajax({
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/view_form_sections/`,
                    method: "POST",
                    headers: {
                        "Authorization": `Token ${this.getToken()}`,
                        "Content-Type": "application/json"
                    },
                    data: JSON.stringify(payload),
                    success: (response) => {
                        this.sections = response.sections;

                        resolve();
                    },
                    error: (error) => {
                        Swal.fire({
                            icon: "error",
                            title: "Failed to load sections",
                            position: 'bottom-end',
                            showConfirmButton: false,
                            timer: 3000,
                            toast: true
                        });
                        reject(error);
                    }
                });
            });
        },
        createSection() {
            if (!this.section_name) {
                Swal.fire({
                    icon: 'error',
                    title: 'Section name is required',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                });
                return;
            }

            const formData = new FormData();
            const form_id = this.$route.params.form_id;
            formData.append('section_name', this.section_name);
            formData.append('form_id', form_id);
            formData.append('is_locked', this.is_locked);

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_section/`,
                method: "POST",
                headers: { Authorization: `Token ${this.getToken()}` },
                data: formData,
                processData: false,
                contentType: false,
                success: (response) => {
                    if (response.status === "success") {
                        Swal.fire({
                            icon: "success",
                            title: "Section created",
                            showConfirmButton: false,
                            timer: 1000,
                            position: 'bottom-end',
                            toast: true
                        }).then(() => {
                            this.fetchSections();
                            this.resetForm();
                            $('#create_section').modal('hide');
                        });
                    }
                },
                error: (response) => {
                    this.errors.section_name = response.responseJSON.message || {};
                }
            });
        },

        deleteSection(id) {
            Swal.fire({
                title: "Are you sure?",
                text: "This will permanently delete the section.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, delete it!",
                position: 'bottom-end',
                toast: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/delete_section/${id}/`,
                        method: "DELETE",
                        headers: { Authorization: `Token ${this.getToken()}` },
                        success: () => {
                            this.fetchSections();
                            Swal.fire({
                              title: "Deleted!",
                              text: "The section has been deleted.",
                              icon: "success",
                              position: 'bottom-end',
                              showConfirmButton: false,
                              timer: 3000,
                              toast: true
                            });
                        },
                        error: () => {
                            Swal.fire({
                              title: "Error",
                              text: "Failed to delete section.",
                              icon: "error",
                              position: 'bottom-end',
                              showConfirmButton: false,
                              timer: 3000,
                              toast: true
                            });
                        }
                    });
                }
            });
        },

        resetForm() {
            this.section_name = '';
            this.question_text = '';
            this.question_type = '';
            this.errors = {};
        },

        editSectionName(section) {
            if (section) {
                this.edit_section = section.name;
                this.edit_section_id = section.id;
            }
        },

        editSection(section) {
            const payload = {
                section_id: section.id,
                update_values: {
                    name: this.edit_section
                },
            };

            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/update_section/`,
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                contentType: 'application/json',
                data: JSON.stringify(payload),
                success: (response) => {
                    const status = response.status;
                    if (status === "success") {
                        const updatedSection = this.sections.find(s => s.id === section.id);
                        if (updatedSection) {
                            updatedSection.name = this.edit_section;
                        }

                        Swal.fire({
                            icon: 'success',
                            title: 'Updated',
                            text: 'Section has been updated.',
                            showConfirmButton: false,
                            timer: 1000,
                            position: 'bottom-end',
                            toast: true
                        });
                        $(`#edit_section_${section.id}`).modal('hide');
                    }
                },
                error: () => {
                    Swal.fire({
                      title: "Error",
                      text: "Failed to update section.",
                      icon: "error",
                      position: 'bottom-end',
                      showConfirmButton: false,
                      timer: 3000,
                      toast: true
                    });
                }
            });
        },
    }
};
